export * from "./LabelCollectionMaterial";
export * from "./PickingLineBasicMaterial";
export * from "./PickingLineMaterial";
export * from "./PickingMeshBasicMaterial";
export * from "./PickingMeshPhongMaterial";
export * from "./PickingMeshPhysicalMaterial";
export * from "./PickingMeshStandardMaterial";
export * from "./PickingPointsMaterial";
export * from "./PickingSpriteMaterial";
export function mySetValuesImpl(self, values) {
    if (values === undefined)
        return;
    for (const key in values) {
        const newValue = values[key];
        if (newValue === undefined) {
            // console.warn( 'THREE.Material: \'' + key + '\' parameter is undefined.' );
            continue;
        }
        const currentValue = self[key];
        if (currentValue === undefined) {
            // console.warn( 'THREE.' + self.type + ': \'' + key + '\' is not a property of this material.' );
            continue;
        }
        if (currentValue && currentValue.isColor) {
            currentValue.set(newValue);
        }
        else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) {
            currentValue.copy(newValue);
        }
        else {
            self[key] = newValue;
        }
    }
}
